import { APP_NAME } from "@constants/app.constants";
import FileUploadComponent from "@screens/inventory/inventory-fileuploads/inventory-file-upload-list/file-upload.component";

const inventoryFileUploadRoutes = [
  {
    name: `Inventory File Uploads - ${APP_NAME}`,
    path: "/inventory/uploads",
    icon: "layout",
    component: FileUploadComponent,
  },
];

export default inventoryFileUploadRoutes;
